import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { useLocation } from 'react-router-dom';
import MatchdayHero from './MatchdayHero';

const MATCHDAY_STAGE_ID = 'aox-matchday-stage';

const MatchdayPortal = () => {
  const location = useLocation();
  const [mountNode, setMountNode] = useState(null);

  useEffect(() => {
    if (location.pathname !== '/') {
      setMountNode(null);
      document.getElementById(MATCHDAY_STAGE_ID)?.remove();
      return undefined;
    }

    let cancelled = false;
    let timer = null;
    let tries = 0;

    const mountStage = () => {
      if (cancelled) return;

      const sections = Array.from(document.querySelectorAll('section'));
      const hero = sections.find((section) =>
        section.classList.contains('relative') &&
        section.classList.contains('flex') &&
        section.classList.contains('items-center') &&
        section.classList.contains('justify-center')
      );

      if (hero?.parentNode) {
        let stage = document.getElementById(MATCHDAY_STAGE_ID);
        if (!stage) {
          stage = document.createElement('div');
          stage.id = MATCHDAY_STAGE_ID;
          stage.setAttribute('data-aox-matchday-stage', 'true');
          hero.parentNode.insertBefore(stage, hero);
        }
        setMountNode(stage);
        return;
      }

      tries += 1;
      if (tries < 20) timer = window.setTimeout(mountStage, 100);
    };

    mountStage();

    return () => {
      cancelled = true;
      if (timer) window.clearTimeout(timer);
      setMountNode(null);
      document.getElementById(MATCHDAY_STAGE_ID)?.remove();
    };
  }, [location.pathname]);

  if (!mountNode) return null;
  return createPortal(<MatchdayHero />, mountNode);
};

export default MatchdayPortal;
